export default defineNuxtPlugin(() => {
  const renderDynamicStrings = (text: string | undefined = '') => {
    const { dynamicStrings } = useDynamicStrings()

    let textWithDynamicStrings = text

    // Find all dynamic strings in curly braces
    const dynamicStringIds = [...text.matchAll(/(\{[a-z]+(-?[a-z]+)+\})/g)].map(
      (id) => id[0],
    )

    if (dynamicStringIds.length) {
      // Create key:value pairs
      const stringPairs = [] as { key: string; value: string }[]
      for (const dynamicString of dynamicStringIds) {
        const id = dynamicString.replace(/[{}]/g, '') // Remove curly braces
        stringPairs.push({
          key: dynamicString,
          value: dynamicStrings[id],
        })
      }

      // Concatenate dynamic strings
      const regexStringPairs = stringPairs
        .map((stringPair) => Object.values(stringPair)[0])
        .join('|')

      // Build regex
      const dynamicRegex = new RegExp(`(?:${regexStringPairs})`, 'g')

      // Parse dynamic strings
      textWithDynamicStrings = textWithDynamicStrings.replace(
        dynamicRegex,
        (matched) => {
          const match = stringPairs.find(
            (stringPair) => stringPair.key === matched,
          )
          const { value = '' } = match || {}
          return value
        },
      )
    }

    return textWithDynamicStrings
  }

  return {
    provide: {
      renderDynamicStrings,
    },
  }
})
